import { get, trim } from 'lodash';

import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { closeNotification, danger } from 'redux-store/reducers/common-reducer';
import { trackSignUp } from '../../tracking/utils/tracking';
import { login } from './session';

import { API, post } from 'utils/api';
import { t } from 'utils/language';
import { logError } from 'utils/log';

export const DEFAULT_SIGNUP_ERROR_MESSAGE = t('signup_default_error_message');

const { ORGANIZATIONS } = API.END_POINTS.API;

function createOrganization(data) {
  const suppressAuth = true;
  const url = ORGANIZATIONS;

  return (dispatch) => {
    dispatch(showLoading(url));

    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(window.app.env.CAPTCHA_SITE_KEY, { action: 'login' }).then(captchaToken => {
          const dataWithToken = {
            ...data,
            captchaToken
          };

          return post(ORGANIZATIONS, { data: dataWithToken }, { suppressAuth })
            .then((response) => {
              const organization = response.data;

              dispatch(hideLoading(url));
              trackSignUp(organization);

              resolve(organization);
            })
            .catch((error) => {
              dispatch(closeNotification());

              if (error.response) {
                const validationErrors = get(error.response, 'data.source.validation_errors') || [];
                const isEmailInUse = validationErrors.some((e) => e.type === 'email');

                const message = isEmailInUse ? t('signup_email_already_being_used') : DEFAULT_SIGNUP_ERROR_MESSAGE;
                dispatch(danger(message));
              } else {
                dispatch(danger(error.message));
              }

              dispatch(hideLoading(url));

              reject(error);
            });
        });
      });
    });
  };
}

export function registerInfluencerUser(user) {
  const data = {
    organization: {
      type: 'influencer',
      name: `${trim(user.firstName)} ${trim(user.lastName)}`
    },
    user
  };

  return async (dispatch) => {
    try {
      await dispatch(createOrganization(data));
      await dispatch(login(user)); // also redirects to main page, which is profile creation page in this case
    } catch (error) {
      logError(error);
    }
  };
}
